<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-24 19:53:46
 * @Description: 官网首页
 -->

<template>
  <div class="promise-file-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/promise-file-01.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/promise-file-02.png" alt="" srcset="" />
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.promise-file-wrapper {
  img {
    width: 100%;
  }
}
</style>
